/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* globals angular $ */
import CONSTANTS from '~/constants'

export default [
  '$rootScope',
  'storyService',
  'contentTemplatesService',
  Clipboard,
]

let timer = null
function bindDraggable() {
  if (timer) {
    window.clearTimeout(timer)
  }
  const newClipItems = $(
    'clipboard [data-ellipsis="clipboard"] .clipboard-item'
  ).not('.ui-draggable')
  if (newClipItems.length) {
    newClipItems.draggable({
      connectToSortable: '#story-wrapper',
      appendTo: '#story-wrapper',
      forceHelperSize: true,
      scroll: false,
      helper: function (evt) {
        const elem = $(evt.currentTarget)
        const id = elem.data('id')
        const type = elem.data('type')
        const img = elem.find('img')
        const text = $.trim(elem.clone().children().text()) || type

        const elems = $('<div/>')
        if (img.length) {
          elems.append(img.clone())
        }
        elems.append(`<p>${text}</p>`)

        return $(`<p data-context="clipboard" data-id="${id}" data-type="${type}"
            class="temp helper drag-view"></p>`)
          .append(elems)
          .height('100px')
          .width('200px')
      },
    })
  } else {
    timer = window.setTimeout(bindDraggable, 10)
  }
}

function Clipboard($rootScope, storyService, contentTemplatesService) {
  this.CONSTANTS = CONSTANTS

  this.$onInit = () => {
    if (
      this.storyObj.additional_properties.clipboard &&
      Object.keys(this.storyObj.additional_properties.clipboard).length
    ) {
      bindDraggable()
    }
  }

  this.remove = function (item) {
    const items = this.storyObj.additional_properties.clipboard[item.type]
    for (let i = 0; i < items.length; i++) {
      if (items[i]._id === item._id) {
        items.splice(i, 1)
        if (items.length < 1) {
          delete this.storyObj.additional_properties.clipboard[item.type]
          break
        }
        break
      }
    }
  }

  this.hasPreview = function (type) {
    return contentTemplatesService.getPreview(type) !== undefined
  }

  this.preview = function (item) {
    const prevFnc = contentTemplatesService.getPreview(item.type)
    if (prevFnc) prevFnc(item)
  }

  this.add = function (item) {
    $('#story-wrapper').trigger('insertNewElement', [item.type, item])
    this.remove(item)
  }

  this.getTemplate = function (key, prop) {
    return contentTemplatesService.get(key)[prop]
  }

  this.cleanText = function (html) {
    return angular.element('<div></div>').html(html).text()
  }

  $rootScope.$on('DISPATCH', (info, action) => {
    if (action.type === 'CLIPBOARD_MODIFIED') {
      bindDraggable()
    }
  })
}
